import { useState, useEffect } from "react";
import "./ContactUsSection1.css";
import { useTranslation } from "react-i18next";

function ContactUsSection1() {
  const { t } = useTranslation("global");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [updatesChecked, setUpdatesChecked] = useState(false);
  const [notification, setNotification] = useState("");
  const [source, setSource] = useState("");
  const [domain, setDomain] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Tag the form with the current page path and domain as its source
      setSource(window.location.pathname);
      setDomain(window.location.hostname);
    }
  }, []);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!validateEmail(email)) {
      setNotification(t("contactUsSection1.notifications.invalidEmail"));
      return;
    }

    if (!email) {
      setNotification(t("contactUsSection1.notifications.emailRequired"));
      return;
    }

    if (!message) {
      setNotification(t("contactUsSection1.notifications.messageRequired"));
      return;
    }

    if (!privacyChecked) {
      setNotification(t("contactUsSection1.notifications.privacyRequired"));
      return;
    }

    const formData = {
      access_key: "6cf44a39-1901-4dbb-85f5-1c03c7cfc77b",
      email,
      message,
      updates: updatesChecked ? "Yes" : "No",
      source, // include the origin tag
      domain, // include the domain
    };

    console.log("Payload being sent:", formData);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (result.success) {
        setNotification(t("contactUsSection1.notifications.success"));
        setEmail("");
        setMessage("");
        setPrivacyChecked(false);
        setUpdatesChecked(false);
      } else {
        setNotification(t("contactUsSection1.notifications.error"));
      }
    } catch (error) {
      console.error("Error:", error);
      setNotification(t("contactUsSection1.notifications.error"));
    }
  };

  return (
    <section className="contact-form-section">
      <div className="contact-form-container">
        {notification && (
          <div className="notification-contactus" role="alert">
            {notification}
          </div>
        )}
        <form onSubmit={onSubmit} className="contact-form">
          {/* Hidden fields for source tagging and domain */}
          <input type="hidden" name="source" value={source} />
          <input type="hidden" name="domain" value={domain} />

          <header>
            <h1 className="form-title">{t("contactUsSection1.formTitle")}</h1>
          </header>

          <fieldset className="form-group">
            <label htmlFor="email" className="form-label">
              {t("contactUsSection1.emailLabel")}
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-input"
            />
          </fieldset>

          <fieldset className="form-group">
            <label htmlFor="message" className="form-label">
              {t("contactUsSection1.messageLabel")}
            </label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows={6}
              className="form-textarea"
            />
          </fieldset>

          <section className="checkbox-section">
            <fieldset className="checkbox-group">
              <div className="checkbox-container">
                <input
                  id="privacy"
                  type="checkbox"
                  checked={privacyChecked}
                  onChange={() => setPrivacyChecked(!privacyChecked)}
                  required
                  className="checkbox-input"
                />
              </div>
              <label htmlFor="privacy" className="checkbox-label">
                {t("contactUsSection1.privacyCheckboxLabel")}
              </label>
            </fieldset>

            <article className="privacy-text">
              <h3>{t("contactUsSection1.privacyText.heading")}</h3>
              <p>{t("contactUsSection1.privacyText.paragraph1")}</p>
              <p>
                {t("contactUsSection1.privacyText.paragraph2Part1")}{" "}
                <a
                  href="http://examplesite.com/privacy_policy"
                  className="privacy-link"
                >
                  http://examplesite.com/privacy_policy
                </a>
                {t("contactUsSection1.privacyText.paragraph2Part2")}
              </p>
            </article>

            <fieldset className="checkbox-group">
              <input
                id="updates"
                type="checkbox"
                checked={updatesChecked}
                onChange={() => setUpdatesChecked(!updatesChecked)}
                className="checkbox-input"
              />
              <label htmlFor="updates" className="checkbox-label">
                {t("contactUsSection1.updatesCheckboxLabel")}
              </label>
            </fieldset>
          </section>

          <div className="button-container">
            <button type="submit" className="submit-button">
              {t("contactUsSection1.submitButton")}
            </button>
          </div>
        </form>
      </div>
      <hr className="divider-line" />
    </section>
  );
}

export default ContactUsSection1;
